/* eslint-disable max-len */
import { useDispatch, useSelector } from 'react-redux';
import { setMediaKitData } from '../../../redux/MediakitRedux';
import { getFolder } from '../../actions/media_actions';
import { useContext, useEffect } from 'react';
import { MediaContext } from '..';
import { API } from 'aws-amplify';
import CustomTempGetMyFolderQuery from './CustomTempGetMyFolderQuery';

/* eslint-disable no-console */

const useCustomTemplate = ({ debounceSearchTerm = '' }) =>
{
	const dispatch = useDispatch();
	const { mediaState, setMediaState } = useContext(MediaContext);
	const { myTemplateData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const { tab } = useContext(MediaContext);
	const query = CustomTempGetMyFolderQuery(debounceSearchTerm);

	const getCount = async () =>
	{
		query.count = true;

		try
		{
			const res = await getFolder(query, 'getTemplates');

			if (res?.status)
			{
				setMediaState({ type: 'setCount', payload: { myTemplates: res?.count } });
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	let folderPromise:any = '';
	const getTemplatesData = async (filter = '') =>
	{
		const newArr:any = filter?.split(',');
		const updateArr:any = newArr?.length > 0 && newArr.map((item) => Number(item));

		if (filter && filter !== '1,2,3,4,5') { query.mediaType = JSON.stringify(updateArr); }
		mediaState?.page === 0 && (myTemplateData?.length === 0 || debounceSearchTerm) && setMediaState({ type: 'updateReducer', payload: { loading: true } });
		try
		{
			folderPromise = getFolder(query, 'getTemplates');

			const res = await folderPromise;

			if (res?.status)
			{
				mediaState?.page === 0 && (res?.data?.length >= 12 ? getCount() : setMediaState({ type: 'setCount', payload: { myTemplates: res?.data?.length } }));
				dispatch(setMediaKitData({ myTemplateData: mediaState?.page > 0 ? [ ...myTemplateData, ...res.data ] : res?.data }));
				setMediaState({ type: 'updateReducer', payload: { loading: false } });
			}
		}
		catch (err)
		{
			console.log(err);
			setMediaState({ type: 'updateReducer', payload: { loading: false } });
		}
	};

	useEffect(() =>
	{
		return () =>
		{
			API.cancel(folderPromise, 'cancelled by user');
		};
	}, [ tab, mediaState?.sort ]);

	return getTemplatesData;
};

export default useCustomTemplate;